import Widgets from '@/widgets'


export default [
	{name:'old_password', widget:Widgets.input, attrs: { type:'password', required:true, placeholder:"Старый пароль", }, label:"Старый пароль:", },
	{name:'new_password', widget:Widgets.input, attrs: { type:"password", required:true, placeholder:"Новый пароль", },   label:"Новый пароль:", },
]
